import { Dialog, Button, Typography, Tabs, Tab } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import SeniorMatrix from "./matrices/SeniorMatrix";
import JuniorMatrix from "./matrices/JuniorMatrix";
import UnlicensedMatrix from "./matrices/UnlicensedMatrix";
import "./MatrixModal.scss";

interface MatrixModalProps {
  evaluationType?: string;
  hasRos?: boolean;
  tortuga?: boolean;
}

const MatrixModal = ({ evaluationType, hasRos, tortuga }: MatrixModalProps) => {
  const [open, setOpen] = useState(false);
  const [openTab, setOpenTab] = useState<string>("unlicensed");

  return (
    <div>
      <Button
        variant="contained"
        className="blue-button mr-2"
        onClick={() => setOpen(true)}
        style={{ marginLeft: "8px" }}
      >
        Show Review Matrix
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        className="matrix-modal"
        id="matrix-modal"
        maxWidth="md"
        fullWidth
      >
        <div className="modal-header">
          <Typography variant="h3" id="modal-title">
            Review Matrix
          </Typography>
          <Button onClick={() => setOpen(false)} className="grey-link-button">
            <CloseIcon />
          </Button>
        </div>
        <div className="modal-body">
          {evaluationType === "all" ? (
            <>
              <Tabs value={openTab} onChange={(_, newValue) => setOpenTab(newValue)}>
                <Tab label="Unlicensed" value="unlicensed" />
                <Tab label="Junior" value="junior" />
                <Tab label="Senior" value="senior" />
              </Tabs>
              {openTab === "senior" && 
                <SeniorMatrix 
                  tortuga = {tortuga}
                  hasRos = {hasRos}
                />
              }
              {openTab === "junior" && <JuniorMatrix />}
              {openTab === "unlicensed" && <UnlicensedMatrix />}
            </>
          ) : (
            <>
              {evaluationType === "senior" && 
                <SeniorMatrix 
                  tortuga = {tortuga}
                  hasRos = {hasRos}
                />}
              {evaluationType === "junior" && <JuniorMatrix />}
              {evaluationType === "unlicensed" && <UnlicensedMatrix />}
            </>
          )}
        </div>
        <div className="modal-footer">
          <Button className="outline-button-small" onClick={() => setOpen(false)}>
            Close
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

export default MatrixModal;
